<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <div class="login-logo-img">
            <img :src="logo1" />
      </div>
      <login-card header-color="grey">
        <h3 slot="title" class="title">Zink It!</h3>

        <md-field class="md-form-group login-field" slot="inputs">
          <md-icon class="login-icon">email</md-icon>
          <label>Email...</label>
          <md-input
            v-model="email"
            type="email"
            @keyup.enter="attempLogin"
          ></md-input>
        </md-field>

        <md-field class="md-form-group login-field" slot="inputs">
          <md-icon class="login-icon">lock_outline</md-icon>
          <label>Password...</label>
          <md-input
            v-model="password"
            type="password"
            @keyup.enter="attempLogin"
          ></md-input>
        </md-field>

        <v-progress-circular
          v-if="loading"
          indeterminate
          class="loginLoader"
          slot="loader"
        ></v-progress-circular>
  
        <md-button
          v-on:click="attempLogin"
          slot="footer"
          class="login-button"
        >
          <h4>LOGIN</h4>
        </md-button>

        <a slot="forgotpassword" class="forgotpassword" @click="$router.push('/forgotpassword')">
          Forgot Password?</a>

        <v-alert v-if="error" class="errorMsg" slot="response">{{
          errorMessage
        }}</v-alert>
      </login-card>

    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import {mapGetters} from 'vuex';

export default {
  components: {
    LoginCard,
  },
  props: {
    logo1: {
      type: String,
      default: require("@/assets/img/zink-automated-finance-software.png")
    },
  },

  data() {
    return {
      loading: false,
      email: "",
      password: "",
      error: false,
      errorMessage: null,
      data: null,
    };
  },
  mounted() {
    this.errorCaptured();
  },
  computed: {
    ...mapGetters([
      "user",
    ]),
  },

  methods: {
    errorCaptured(){
      if(this.$route.params.data.errorMessage !== null){
        this.error = true;
        this.errorMessage =  this.$route.params.data.errorMessage;
      }
    },
    async attempLogin() {
      this.loading = true;

      let status = await this.$store.dispatch('attempt_user_login', { email: this.email, password: this.password });

      if (status === true) {
        // Check if the tracker is initialized before setting the user ID
        if (this.$tracker && typeof this.$setUserId === 'function') {
          const newUserId = this.user.email;
          this.$setUserId(newUserId);
        } else {
          console.error("Tracker is not initialized or $setUserId is not available.");
        }

        this.$router.push("/");
      } else {
        this.error = true;
        this.errorMessage = status;
      }

      this.loading = false;
    },


    getCSRF() {
      const self = this;
      self.loading = true;
      axios
        .get("/sanctum/csrf-cookie")
        .then(function (response) {
          self.login();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    login() {
      const self = this;
      self.loading = true;
      axios
        .post("/login", {
          email: self.email,
          password: self.password,
        })
        .then(function (response) {
          self.$router.push("/");
        })
        .catch(function (error) {
          self.error = true;
          self.errorMessage = error.response.data;
          self.loading = false;
        });
    }
  },
};
</script>

<style lang="scss">
@import '../assets/scss/theme.scss';
@import '../assets/scss/md-custom/_ausloans-colors.scss';
.errorMsg {
  background-color: red;
  color: white;
}
.loginLoader {
  color: $ausloans-green;
}
.login-logo-img {
  max-width: 340px;
  padding-bottom: 3rem;
  margin: 0 auto;
}
.login-button {
  background-color: $ausloans-green !important;
  color: white !important;
  border-radius: 3px;
  width: 100%;
}
.login-button:Hover {
    background-color: $ausloans-green-dark !important;
}
.login-field {
  margin-top: 30px;
}
.login-icon {
    margin-left: 5px !important;
    margin-right: -5px !important;
}
.attentionMsgHighlight {
  background-color: red !important;
  border-color: white !important;
  color: white !important;
}
.forgotpassword{
  cursor: pointer;
}
</style>
